/* eslint-disable @typescript-eslint/no-var-requires */
import React, {
  FunctionComponent,
  MutableRefObject,
  useRef,
  useState,
} from 'react';

import './animation021.less';
import ImgPoint from '../../../../../assets/animation_point.gif';
import { Button, Modal } from 'antd';

interface IAnimation021Item {
  icon: string;
  text: string;
  viewMore?: boolean;
  tip?: string;
}

interface IAnimation021Props {
  items: IAnimation021Item[];
  pic: string;
  inTitle: string;
  onCompleted: () => void;
}

const Animation021: FunctionComponent<IAnimation021Props> = ({
  pic,
  inTitle,
  items,
  onCompleted,
}) => {
  const crrRef = useRef() as MutableRefObject<HTMLDivElement>;
  const [play, setPlay] = React.useState(1);
  const [isPlayed, setIsPlayed] = React.useState(false);
  const startPlay = (next = 1) => {
    if (isPlayed) {
      return;
    }
    next += 1;
    setPlay(next);
    setIsPlayed(true);
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1000);
    } else {
      console.log('Animation021 onCompleted');
      onCompleted && onCompleted();
    }
  };
  const getImg = (img: string) =>
    require(`../../../../../assets/${img}`).default;

  const [isModalOpen, setModalOpen] = useState(false);
  const [show, setShow] = useState(true);
  return (
    <div ref={crrRef} className="animation021 component">
      <div className="animation021-content">
        {items.map((itm: IAnimation021Item, idx: number) => (
          <div
            key={idx}
            className={`animation021-item animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
            onClick={() => startPlay()}
            style={{
              width: `${(1 / items.length) * 100 - 2}%`,
            }}
          >
            {idx % 2 === 0 ? (
              <>
                <img
                  className={`click-point ${play > 1 ? 'hide' : ''}`}
                  src={ImgPoint}
                  alt=""
                />
                <div className="animation021-text">
                  {itm.text}
                  {itm.viewMore ? (
                    <div className="view-more">
                      <Button
                        className="view-more-btn"
                        onClick={() => {
                          setModalOpen(true);
                          setShow(false);
                        }}
                        type="link"
                      >
                        {itm.tip}
                      </Button>
                      <img
                        className="click-point1"
                        hidden={!show}
                        src={ImgPoint}
                        alt=""
                      />
                    </div>
                  ) : null}
                </div>
                <div className="animation021-icon">
                  <img src={getImg(itm.icon)} alt="" />
                </div>
              </>
            ) : (
              <>
                <img
                  className={`click-point ${play > 1 ? 'hide' : ''}`}
                  src={ImgPoint}
                  alt=""
                />
                <div className="animation021-icon">
                  <img src={getImg(itm.icon)} alt="" />
                </div>
                <div className="animation021-text">
                  {itm.text}
                  {itm.viewMore ? (
                    <div className="view-more">
                      <Button
                        className="view-more-btn"
                        onClick={() => {
                          setModalOpen(true);
                          setShow(false);
                        }}
                        type="link"
                      >
                        {itm.tip}
                      </Button>
                      <img
                        className="click-point1"
                        hidden={!show}
                        src={ImgPoint}
                        alt=""
                      />
                    </div>
                  ) : null}
                </div>
              </>
            )}
          </div>
        ))}
      </div>
      <Modal
        width="60%"
        className="animation021-modal"
        title={inTitle}
        footer={null}
        visible={isModalOpen}
        onCancel={() => setModalOpen(false)}
      >
        <img src={require(`../../../../../assets/${pic}`).default} alt="" />
      </Modal>
    </div>
  );
};

export default Animation021;
